var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav" },
    [
      _vm._l(_vm.menu, function (item, index) {
        return _c("div", { key: `${item.name}-${item.value}-${index}` }, [
          item.value !== 2
            ? _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.showStatus || item.showStatus == undefined,
                        expression:
                          "item.showStatus || item.showStatus == undefined",
                      },
                    ],
                    staticClass: "nav-item",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "nav-item-title",
                        class: {
                          active: item.path
                            ? _vm.active.indexOf(item[_vm.activeKey]) > -1
                            : _vm.active === item[_vm.activeKey],
                          nav: _vm.activeKey === "path",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.change(item)
                          },
                        },
                      },
                      [
                        item.value === 0
                          ? _c("svg-icon", { attrs: { name: "suo" } })
                          : _vm._e(),
                        _c("span", { class: item.value === 0 ? "ncole" : "" }, [
                          _vm._v(" " + _vm._s(_vm.$t(item.name)) + " "),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      }),
      _vm.AiGptShow !== 2
        ? _c(
            "div",
            { staticClass: "nav-item aigpt", on: { click: _vm.openAI } },
            [
              _vm.AiGptShow === 0
                ? _c("svg-icon", { attrs: { name: "suo" } })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "aigpt-box" },
                [
                  _c("el-image", {
                    class: _vm.AiGptShow === 0 ? "ncole" : "",
                    attrs: {
                      fit: "contain",
                      src: require("@/assets/AIGPT/AIChat.png"),
                    },
                  }),
                  _c("span", [_vm._v("TradeGPT")]),
                  _c("svg-icon", {
                    staticClass: "beta",
                    attrs: { name: "beta" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("tipOpen", {
        ref: "openTips",
        on: { changeStatus: _vm.changeStatus },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }